<script>
import { authComputed } from '@/state/helpers'
import { required, email } from 'vuelidate/lib/validators'
import api from '@/helpers/api'
export default {
  name: 'account.profile.general',
  data: () => ({
    form: {
      preferences: {}
    },
    lang: null,
    isLoading: false
  }),
  computed: {
    ...authComputed
  },
  mounted () {
    this.onInit()
  },
  methods: {
    async onInit () {
      this.form = {
        ...this.userProfile
      }

      this.lang = this.userProfile.preferences
        ? this.userProfile.preferences.language
        : null
      this.$v.$reset()
    },
    async onSave () {
      this.$v.$touch()
      if (!this.$v.$error) {
        const { id, email, firstname, lastname } = this.form

        try {
          this.isLoading = true
          await api.users.update({
            id,
            firstname,
            lastname,
            name: `${firstname} ${lastname}`,
            email
          })
          await api.users.updatePreference({
            id,
            option: 'language',
            value: this.lang
          })
          this.$store.dispatch('auth/fetchUserProfile', { id })
          this.isLoading = false
        } catch (error) {
          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    },
    onCancel () {
      this.form = { ...this.userProfile }
      this.lang = null
      this.$v.$reset()
    }
  },
  validations: {
    form: {
      firstname: {
        required
      },
      name: {
        required
      },
      email: {
        required,
        email
      }
    },
    lang: {
      required
    }
  }
}
</script>
<template>
  <b-card>
    <g-overlay :show="isLoading || !userProfile">
      <h4 class="font-weight-light mb-3">Profile</h4>
      <g-form-error-wrapper :validations="$v.form.firstname">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            :label="$t('first name')"
            v-model="form.firstname"
            :error-messages="errors"
            maxWidth="300px"
            :is-valid="!invalid"
            v-on:blur="$v.form.firstname.$touch()"
            label-cols-sm="3"
            label-cols-lg="2"
            label-cols-xl="2"
          />
        </template>
      </g-form-error-wrapper>
      <g-text-input
        :label="$t('last name')"
        v-model="form.lastname"
        maxWidth="300px"
        label-cols-sm="3"
        label-cols-lg="2"
        label-cols-xl="2"
      />

      <g-form-error-wrapper :validations="$v.form.email">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            :label="$t('email')"
            v-model="form.email"
            :error-messages="errors"
            maxWidth="300px"
            :is-valid="!invalid"
            v-on:blur="$v.form.email.$touch()"
            label-cols-sm="3"
            label-cols-lg="2"
            label-cols-xl="2"
          />
        </template>
      </g-form-error-wrapper>

      <b-form-group
        label="Language"
        label-for="language"
        label-cols-sm="3"
        label-cols-lg="2"
        label-cols-xl="2"
      >
        <app-language-select
          v-model="$v.lang.$model"
          :style="{ maxWidth: '300px' }"
        />
      </b-form-group>
      <div class=" d-flex align-items-end justify-content-end">
        <b-btn
          variant="link"
          class="mr-2"
          v-on:click="onCancel"
          :disabled="!$v.$anyDirty"
        >
          Cancel
        </b-btn>
        <b-btn
          variant="primary"
          class=" d-flex align-items-center btn-label"
          v-on:click="onSave"
          :disabled="!$v.$anyDirty"
        >
          <i class="bx bx-save label-icon"></i>Save Changes
        </b-btn>
      </div>
    </g-overlay>
  </b-card>
</template>
